import { AuthTokenInterface } from '../../..';
import { UserDto } from './user.dto';

export class AuthTokensDto implements AuthTokenInterface { 
  id: string;
  user: UserDto;
  refreshTokenHashed: string;
}
